import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import logo_white from 'img/tf-logos/logo-white.svg'

import './HeaderApplicationPage.scss'

interface HeaderApplicationPageProps {
	isLogoutButtonShown?: boolean
}

const HeaderApplicationPage = ({
	isLogoutButtonShown = true,
}: HeaderApplicationPageProps) => {
	const { t } = useTranslation()

	return (
		<header className="header-applicationpage">
			<div className="container header-container">
				<div className="container d-flex align-items-center justify-content-between h-100">
					<img
						src={logo_white}
						className="img-responsive tfbank-logo-header"
						alt="logo"
					/>
					<div className="sign-out d-flex align-items-center">
						{isLogoutButtonShown ? (
							<Link
								className="btn btn-secondary btn-light"
								to="/logout">
								{t('SignOut')}
							</Link>
						) : null}
					</div>
				</div>
			</div>
		</header>
	)
}

export default HeaderApplicationPage
